import { Component, OnInit } from '@angular/core';
import { FeriasBaseComponent } from '../ferias-base.component';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AlertMessageService } from '@sigepe/sigepe-template';

@Component({
    selector: 'app-gerenciar-ferias',
    templateUrl: './gerenciar-ferias.component.html'
})
export class GerenciarFeriasComponent extends FeriasBaseComponent implements OnInit {
    constructor(
        alertaMsgService: AlertMessageService,
        private router: Router
    ) {
        super(alertaMsgService);
    }

    ngOnInit(): void {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
            if ((event as any).url === '/secure/gerenciar-ferias') {
                this.router.navigate(['/secure/gerenciar-ferias/buscar-agente-publico'], { replaceUrl: true });
            }

            if ((event as any).url === '/secure/gerenciar-ferias/consultar-exercicios') {
                this.alterarTituloTemplate('Gerenciar Férias');
                this.alterarTextoBreadcrumb(1, 'Gerenciar Férias - Buscar Agente Público');
            }
        });

        //No primeiro carregamento redireciona para a tela de buscar agente público
        //somente quando a rota atual é a raiz de gerenciar férias.
        if (this.router.url === '/secure/gerenciar-ferias') {
            this.router.navigate(['/secure/gerenciar-ferias/buscar-agente-publico'], {
                replaceUrl: true
            });
        }
    }
}
